import { useSyncExternalStore } from 'react';

import { useApi } from '../api-context';

/**
 * Jeton courant, réactif. `set`/`clear` notifient les abonnés : un composant
 * monté au moment de la connexion se re-rend sans rechargement de page.
 */
export function useToken(): string | null {
  const api = useApi();
  return useSyncExternalStore(
    api.tokens.subscribe,
    api.tokens.get,
    // Côté serveur (ou pré-hydratation), aucun jeton.
    () => null,
  );
}
